export const filters = state => () => {
    return state.filters
}
export const overlay = state => () => {
    return state.overlay
}
export const mode = state => () => {
    return state.list
}
export const searchEnded = state => () => {
    return state.searchEnded
}
export const applicationId = state => () => {
    return state.applicationId
}
export const proposalId = state => () => {
    return state.proposalId
}
